import React from 'react';
import PropTypes from 'prop-types';
import FloatInput from './FloatInput';
import {checkIfTouchedValue} from './utilities';

// 自動計算中の欄は編集できない。クリックしても無反応なだけだと「壊れている」と
// 受け取られるため、理由と切り替え方をツールチップで示す (#2815)。文言の
// 「マニュアルで給与を編集する」は給与詳細画面の歯車メニューの項目名と揃える。
const AUTO_CALC_TITLE = '自動計算のため編集できません。手入力するには給与詳細画面の歯車アイコンから「マニュアルで給与を編集する」を選んでください';

class FomulaInput extends React.Component {
  autoModeCondition = (userPayroll) => {
    const disabledCondition = this.props.disabledCondition;

    if (disabledCondition) {
      return userPayroll[Object.keys(disabledCondition)[0]] !== Object.values(disabledCondition)[0] && !this.props.manualMode;
    } else {
      return !this.props.manualMode;
    }
  };

  render() {
    const {
      title,
      touched,
      inputType,
      userPayrolls,
      zeroAsNull,
      onInputFocus,
      onInputChange,
      clz
    } = this.props;

    const { delimited } = this.props;

    return (
      <>
        <th className={`item ${clz || 'th2'}`} colSpan={clz == 'th1' ? '2' : '1'}><span>{title}</span></th>
        {userPayrolls.map((userPayroll, index) => {
          const disabled = this.autoModeCondition(userPayroll);
          const rawValue = userPayroll[inputType] || (zeroAsNull ? 0 : '');
          const updatedClass = checkIfTouchedValue(touched, userPayroll.uID, inputType) ? 'updated' : '';

          // #2197: 合計欄(delimited)は読み取り専用時に桁区切り表示する。送信は生値の
          // hidden input が担い、表示用の disabled input には name を付けない
          // (= 送信契約 payment[uID][inputType] を壊さない)。編集可(manual_mode)時は
          // 入力を阻害しないため従来どおり生値の input を出す。
          if (delimited && disabled) {
            return (
              <td className="salary w9" key={index}>
                <input type="hidden" name={`payment[${userPayroll.uID}][${inputType}]`} value={rawValue} />
                <input className={`inputNumber w9 ${updatedClass}`}
                  data-uid={userPayroll.uID}
                  disabled
                  readOnly
                  title={AUTO_CALC_TITLE}
                  type="text"
                  value={rawValue === '' ? '' : Number(rawValue).toLocaleString('en-US')}
                />
              </td>
            );
          }

          return (
            <td className="salary w9" key={index}>
              {/* #2250: 素の input だと IME 変換中イベントを親が破棄し全角入力が
                  巻き戻る。数値のみのカラム (社保/所得税/合計) のため FloatInput
                  (NumberInputRow と同じ) で確定時に半角へ変換 + 不許可文字を削除する。 */}
              <FloatInput className={`inputNumber w9 ${updatedClass}`}
                data-uid={userPayroll.uID}
                disabled={disabled}
                inputType={inputType}
                name={`payment[${userPayroll.uID}][${inputType}]`}
                onChange={(e) => onInputChange(e, index, inputType)}
                onFocus={(e) => onInputFocus(e, userPayroll.uID, inputType)}
                title={disabled ? AUTO_CALC_TITLE : undefined}
                type="text"
                value={rawValue}
              />
            </td>
          );
        })}
      </>
    );
  }
}

FomulaInput.propTypes = {
  touched: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  disabledCondition: PropTypes.object,
  inputType: PropTypes.string.isRequired,
  manualMode: PropTypes.bool.isRequired,
  zeroAsNull: PropTypes.bool.isRequired,
  userPayrolls: PropTypes.array.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onInputFocus: PropTypes.func.isRequired,
  clz: PropTypes.string.isOptional,
  delimited: PropTypes.bool
};

export default FomulaInput;
